import type { ActionTree, ActionContext, Module, MutationTree } from 'vuex';
import { B2C, type ltFramework } from '@life-time-inc/enterprise-framework-core';

const B2CState: ltFramework.IB2CModule = {
	account: null,
	initialized: false
};

const B2CMutations: MutationTree<ltFramework.IB2CModule> = {
	setAccount(state: ltFramework.IB2CModule, payload: typeof B2CState.account) {
		state.account = payload;
	},
	setInitialized(state: ltFramework.IB2CModule, payload: boolean) {
		state.initialized = payload;
	},
	resetAccount(state: ltFramework.IB2CModule) {
		state.account = null;
	}
};

export const B2CActions: ActionTree<ltFramework.IB2CModule, ltFramework.IRootState> = {
	async initialize({
		commit
	}: ActionContext<ltFramework.IB2CModule, ltFramework.IRootState>): Promise<void> {
		try {
			const b2c = new B2C();
			const account = await b2c.getAccount();
			commit('setAccount', account);
		}
		finally {
			commit('setInitialized', true);
		}
	},
	async login(_, redirectStartPage?: string) {
		const b2c = new B2C();
		await b2c.login(redirectStartPage);
	},
	async logout({ commit }) {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		window.ef.alertNotificationStore.open({
			id: 'logout-success',
			type: 'alert-success',
			message: 'You have been logged out successfully.',
			defer: true,
			dismissible: true,
			title: ''
		});

		const b2c = new B2C();
		commit('resetAccount');
		await b2c.logout();
	}
};

export const B2CModule: Module<ltFramework.IB2CModule, ltFramework.IRootState> = {
	namespaced: true,
	state: B2CState,
	actions: B2CActions,
	mutations: B2CMutations
};
